<template>
    <div>
        <h1 class="title ">
            <s-l id="delay_title">Choisissez la durée de votre tournoi :</s-l>
        </h1>
        <div class="notification is-info">
           <s-l id="delay_explain"> La durée se calcule dès que votre tournoi commence<br/>
            Il sera toujours possible de prolonger la durée pendant le tounroi en cours <br/>
            Une fois démarré, vous ne pouvez plus changer la date de début du tournoi</s-l>
        </div>
        <div v-if="!prolonger" class="boxDelay" v-on:click="setDelay('FREE')" :value="selectedFREE">
            <h1 class="delay test"><s-l id="delay_test">MODE TEST - 15 minutes</s-l></h1>
            <div>
                <s-l id="delay_testexplain">15 minutes pour tester l'organisation d'un tournoi...</s-l> <br/>

            </div> 
            <div class="price">
               <s-l id="delay_testprice"> Ce mode est GRATUIT !</s-l><br/>
            </div>
        </div>
        <div :class="credit==0?'boxDisabled':'boxDelay'"  v-on:click="setDelay('8H')" :value="selected8H">
            <h1 :class="credit==0?'boxDisabledTitle':'delay D8H'" >
                <s-l id="delay_8H">Durée de 8H</s-l></h1>
            <div>
                <s-l id="delay_8Hexplain">La durée du tournoi est de 8 heures à compter du démarrage du tournoi</s-l>
            </div> 
            <div class="price">
               <span class="icon">
                <i class="fas fa-coins"></i>
                </span> 1 CREDIT <br/>
            </div>
            <div class="notcredit" v-show="credit==0">
               <s-l id="delay_creditinsuffisant"> Votre crédit est insuffisant</s-l>
            </div>
        </div>
        <div :class="(credit==0 || credit<3)?'boxDisabled':'boxDelay'"  v-on:click="setDelay('3J')" :value="selected3J">
            <h1 :class="(credit==0 || credit<3)?'boxDisabledTitle':'delay D72H'"  >
                <s-l id="delay_72H">Durée de 72H (3 jours)</s-l></h1>
            <div>
                <s-l id="delay_72Hexplain">La durée du tournoi est de 3 jours à compter du démarrage du tournoi</s-l>
            </div> 
            <div class="price">
                <span class="icon">
                <i class="fas fa-coins"></i>
                </span> 3 CREDITS <br/>
            </div>
             <div class="notcredit" v-show="(credit==0 || credit<3)">
               <s-l id="delay_creditinsuffisant"> Votre crédit est insuffisant</s-l>
            </div>
        </div>
        <div :class="(credit==0 || credit<5)?'boxDisabled':'boxDelay'" v-on:click="setDelay('5J')" :value="selected5J">
            <h1 :class="(credit==0 || credit<5)?'boxDisabledTitle':'delay D120H'"   >
                <s-l id="delay_120H">Durée de 120H (5 jours)</s-l></h1>
            <div>
               <s-l id="delay_120Hexplain"> La durée du tournoi est de 5 jours à compter du démarrage du tournoi</s-l>
            </div> 
            <div class="price">
                <span class="icon">
                <i class="fas fa-coins"></i>
                </span> 5 CREDITS <br/>
            </div>
            <div class="notcredit" v-show="(credit==0 || credit<5)">
                <s-l id="delay_creditinsuffisant"> Votre crédit est insuffisant</s-l>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .boxDelay {
        display: inline-block;
        width: 45%;
        min-width: 250px;
        height: 180px;
        background-color: rgb(209, 207, 207);
        padding: 10px;
        margin: 10px;
        border-radius: 20px;
    }
    .notcredit {
        color:rgb(253, 253, 253);
        background-color :rgb(214, 88, 66); 
        font-size: 14px;
        font-style: italic;
        padding: 10px;
        border-radius: 30px;
    }
    .boxDisabled:hover {
        cursor: not-allowed;
    }
    .boxDisabled {
        display: inline-block;
        width: 45%;
        min-width: 250px;
        height: 180px;
        background-color: gray;
        padding: 10px;
        margin: 10px;
        border-radius: 20px;

        color: silver;
        
    }
    .boxDisabledTitle {
        color: silver;
        background-color: rgb(71, 70, 70);
        text-align: center;
    }
    .price {
        font-size: 20px;
        font-weight: bold;
        width: 100%;
        text-align: right;
        margin-top: 10px;
    }
    .delay {
        width: 100%;
        text-align: center;
        padding: 10px;
        font-weight: bold;
        border: thin silver solid;
        margin-bottom: 10px;
    }
    .boxDelay:hover{
        cursor: pointer;
        background-color: rgb(236, 236, 209);
        color: gray;
    }
    .test {
        background-color:rgb(250, 162, 243);
        border-radius: 20px;
    }
    .D8H {
        background-color: rgb(165, 255, 47);
        border-radius: 20px;
        color: gray;
    }
    .D72H {
        background-color: rgb(255, 189, 47);
        border-radius: 20px;
    }
     .D120H {
        background-color: rgb(255, 78, 47);
        color: white;
        border-radius: 20px;
    }
    
    .boxDelay[value="OK"] {
        background-color: greenyellow;
        color: black;
    }
</style>
<script>
export default {
    props: ["options","prolonger"],
    data() {
        return {
            box: "box",
            selectedFREE: "false",
            selected5J: "false",
            selected3J: "false",
            selected8H: "false"
        }
    },
    computed: {
         credit: {
            get() {
            
                    if (this.$store.getters.getCredit == null)
                    return 0;
                    else
                    return this.$store.getters.getCredit.credit
            }
        }
    },
    methods: {
        setDelay(delay) {
            this.selectedFREE= "false",
            this.selected5J= "false",
            this.selected3J= "false",
            this.selected8H= "false"
            switch (delay) {
                case "FREE":
                    this.selectedFREE = "OK";
                    this.options.delay = "FREE";
                    break;
                case "8H":
                    this.selected8H = "OK";
                    this.options.delay = "8H";
                    break;
                case "3J":
                    this.selected3J = "OK";
                    this.options.delay = "3J";
                    break;
                case "5J":
                    this.selected5J = "OK";
                    this.options.delay = "5J";
                    break;
            }   
            this.$emit("setDelay", delay);
        }
    }
}
</script>